import {
  CLIENT_ACCOUNT_PATH,
  CLIENT_TEAM_MEMBERS_PATH,
  CLIENT_INVESTMENT_PLANS_PATH,
  NOTIFICATIONS_PATH,
  UPDATE_USER_DISMISSED_PATH
} from 'utils/Client/apiPaths'

export const BLACK_DIAMOND_API_PATH = '/v1/client/portfolios/'
export const BOX_API_PATH = '/v1/client/documents'
export const SALESFORCE_API_PATHS = [
  `/v1/client${CLIENT_ACCOUNT_PATH}`,
  `/v1/client${CLIENT_TEAM_MEMBERS_PATH}`,
  `/v1/client${CLIENT_INVESTMENT_PLANS_PATH}`,
  `/v1/client${NOTIFICATIONS_PATH}`,
  `/v1/client${UPDATE_USER_DISMISSED_PATH}`
]

export default {
  BLACK_DIAMOND_API_PATH,
  BOX_API_PATH,
  SALESFORCE_API_PATHS,
}



// WEBPACK FOOTER //
// ./src/utils/Client/thirdPartyApiPaths.js